import { useState, useEffect } from 'react';
import useSWR from 'swr';

import { FOCUS_THROTTLE_INTERVAL } from '@/config/appSettings';

import { IResponseError } from '@/lib/apiBase';
import { fetchBaseImageList, IBaseImage, IBaseImageListResponse } from '@/lib/notebooks/notebooksApi';

const useNotebookBaseImages = ({ initialData }: { initialData?: IBaseImageListResponse }) => {
  const [status, setStatus] = useState<'success' | 'error' | 'pending'>('pending');
  const [baseImages, setBaseImages] = useState<IBaseImage[] | undefined>(initialData?.notebook_base_images || []);
  const [error, setError] = useState<IResponseError | undefined>();

  const fetchKey = ['notebookBaseImages'];

  const { data, isLoading, isValidating } = useSWR(fetchKey, () => fetchBaseImageList(), {
    fallback: {
      evaluation: initialData,
      status: 'success',
      isLoading: false,
      statusCode: 200,
      status_message: 'OK',
    },
    keepPreviousData: true,
    revalidateOnFocus: false,
    revalidateOnMount: !initialData,
    revalidateOnReconnect: false,
    focusThrottleInterval: FOCUS_THROTTLE_INTERVAL,
  });

  useEffect(() => {
    if (data) {
      setBaseImages(data?.notebook_base_images);
      setStatus(data?.status);
      setError(data?.error as IResponseError);
    }
  }, [data]);

  return {
    status: status,
    isLoading: isLoading,
    isValidating: isValidating,
    baseImages,
    error: error,
  };
};

export default useNotebookBaseImages;
